import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { ClipLoader } from 'react-spinners'
import { clientHomeConfig } from '../../../_configs/clientHome.config'

// Components
import { Button } from '../../../_components/Button'
import { UploadInvoicesWrapper } from '../../../UploadInvoicesWrapper'

// Actions
import { notificationsActions, modalActions } from '../../../_actions'

// Constants
import { tenantColors } from '../../../_constants/colors'
import ROUTES from '../../../_constants/routes'

// Helpers
import { history } from '../../../_helpers/history'

// Services
import { createEmptyInvoiceSchedule } from '../../../_services/lender.service'

const StyledLegalDiv = styled.div`
  max-width: 500px;

  .title {
    color: #383f44;
    font-weight: 400;
    font-size: 30px;
    letter-spacing: 0.56px;
  }

  .body {
    margin-top: 8px;
    color: #9eaeb6;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0.76px;
    margin-bottom: 16px;
  }

  .button-row {
    text-align: center;
  }
`

class Submit extends React.Component {
  state = {
    uploadingInvoices: false,
    legaleseAgreed: false,
  }

  submitAndClose = () => {
    const { onSubmit = null, closeModal } = this.props
    if (onSubmit !== null) {
      onSubmit()
    }
    closeModal()
  }

  render() {
    const { uploadingInvoices } = this.state
    const { tenant, closeModal } = this.props
    return (
      <>
        <ClipLoader
          color={tenantColors[tenant].secondary}
          cssOverride={{
            display: `block`,
            margin: `0 auto`,
            animationDuration: `1.5s !important`,
          }}
          loading={uploadingInvoices}
          size={100}
        />
        {clientHomeConfig[tenant].details.legalese && !this.state.legaleseAgreed && (
          <StyledLegalDiv className={`legalese`}>
            <p className={`body`}>{clientHomeConfig[tenant].details.legalese}</p>
            <div className="button-row">
              <Button
                onClick={async () => {
                  let emptySchedule = await createEmptyInvoiceSchedule(this.props.business.id)
                  closeModal()
                  history.push(ROUTES.client_invoice_submission + `/${emptySchedule.id}`)
                }}
                text={`Agree`}
              ></Button>
            </div>
          </StyledLegalDiv>
        )}
        {/*
         * FIX:
         * Due to, <ClientHomePage /> won't depend on legalize for invoice redirection
         * the component below isn't needed.
         *
         * Additionally, is only been used by the <ClientHomePage /> component.
         */}
        {!uploadingInvoices && (!clientHomeConfig[tenant].details.legalese || this.state.legaleseAgreed) && (
          <UploadInvoicesWrapper onSubmit={this.submitAndClose} />
        )}
      </>
    )
  }
}

/*

    // Saving this unti we're sure using the upload method in upload invoices is preferred

    const StyledReactDropzone = styled(ReactDropzone)`
        border: 2px dashed black;
        padding: 25px;
        border-radius: 5px;
        text-align: center;
        line-height: 2em;
        opacity: 0.5;
        cursor: pointer;
        transition: all 0.2s ease-in-out;

        &:hover {
            opacity: 0.75;
        }
    `

    handleUploadInvoices = (acceptedFiles, rejectedFiles) => {
        const { business, showNotification, closeModal } = this.props

        if (acceptedFiles.length > 0) {
            this.setState({
                uploadingInvoices: true,
            })
        }

        acceptedFiles.map((file, i) => {
            documentsService
                .uploadInvoiceDocument(file, business.id)
                .then(_ =>
                    showNotification({
                        type: `success`,
                        message: `${file.name} successfully uploaded!`,
                    })
                )
                .catch(_ =>
                    showNotification({
                        type: `error`,
                        message: `There was an error uploading ${file.name}. Please try again.`,
                    })
                )
                .finally(() => {
                    if (i === acceptedFiles.length - 1) {
                        this.setState({
                            uploadingInvoices: false,
                        })
                        closeModal()
                    }
                })
        })

        rejectedFiles.map(file => {
            showNotification({
                type: `warning`,
                message: `${file.name} not valid. File needs to be either an image or a pdf.`,
            })
        })
    }

    <StyledReactDropzone
        onDrop={(acc, rej) => this.handleUploadInvoices(acc, rej)}
        accept={[`image/*`, `.pdf`]}
    >
        <h3>Please select the invoices you would like to submit for funding.</h3>
        <p>PDF files are preferred but images are also allowed.</p>
        <p>
            You can either <strong>click</strong> or <strong>drag and drop</strong> files into this area.
        </p>
    </StyledReactDropzone>
*/

function mapStateToProps(state) {
  const { business, env } = state
  return {
    business,
    tenant: env.tenant,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showNotification: (notification) => {
      dispatch(notificationsActions.showNotification(notification))
    },
    closeModal: () => {
      dispatch(modalActions.closeModal())
    },
  }
}

const connectedSubmit = connect(mapStateToProps, mapDispatchToProps)(Submit)
export { connectedSubmit as Submit }
